import type {Tema} from '@cnc/contracts';
import {useEffect} from 'react';
import {tr} from '../i18n/idioma';

// Tema claro u oscuro (decision 0023). Se guarda en el perfil de cada persona;
// "sistema" sigue la configuracion del computador. Los colores cambian por
// variables CSS (estilos.css, html[data-tema="oscuro"]).
const consulta = () => window.matchMedia?.('(prefers-color-scheme: dark)');

export function aplicarTema(tema: Tema) {
  const oscuro = tema === 'oscuro' || (tema === 'sistema' && consulta()?.matches === true);
  document.documentElement.dataset.tema = oscuro ? 'oscuro' : 'claro';
}

// Aplica el tema mientras la persona esta en la app; con "sistema" escucha los
// cambios del computador. Al salir (pantalla de ingreso) vuelve al claro.
export function useTema(tema: Tema) {
  useEffect(() => {
    aplicarTema(tema);
    const medios = tema === 'sistema' ? consulta() : undefined;
    const alCambiar = () => aplicarTema(tema);
    medios?.addEventListener('change', alCambiar);
    return () => {
      medios?.removeEventListener('change', alCambiar);
      document.documentElement.dataset.tema = 'claro';
    };
  }, [tema]);
}

const NOMBRE: Record<Tema, () => string> = {
  claro: () => tr('Claro', 'Light'),
  oscuro: () => tr('Oscuro', 'Dark'),
  sistema: () => tr('Como el sistema', 'Same as system'),
};
const ICONO: Record<Tema, string> = {claro: '☀', oscuro: '☾', sistema: '◐'};

export const iconoDeTema = (tema: Tema) => ICONO[tema];
export const nombreDeTema = (tema: Tema) => NOMBRE[tema]();
